// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* sidebar */
.DefaultTheme__sidebar___36TsA {
  border-right: 1px solid var(--_apc-sidebar-border, var(--aluminum2));
  flex: 0 0 auto;
  font-family: var(--lume-g-font-family);
  font-size: 14px;
  height: 100%;
  max-height: 100vh;
  overflow-y: auto;
  padding: 20px 0;
  width: 200px;
}
/* back button */
.DefaultTheme__menu-back___1Lwwk {
  --_apc-sidebar-menu-back-text-decoration: var(--_apc-sidebar-menu-back-text-decoration-lume, none);

  align-items: center;
  color: var(--_apc-sidebar-text-color, var(--steel1));
  display: flex;
  margin: 30px 0;
  padding: 0 20px;
  position: relative;
  -webkit-text-decoration: var(--_apc-sidebar-menu-back-text-decoration);
          text-decoration: var(--_apc-sidebar-menu-back-text-decoration);
}
.DefaultTheme__menu-back___1Lwwk:hover {
    --_apc-sidebar-hover-font-weight: var(--_apc-sidebar-hover-font-weight-lume, 400);

    color: var(--steel4);
    font-weight: var(--_apc-sidebar-hover-font-weight);
  }
.DefaultTheme__menu-back___1Lwwk:active,
  .DefaultTheme__menu-back___1Lwwk:focus {
    color: var(--primary);
  }
.DefaultTheme__menu-back___1Lwwk:focus {
    outline: none;
  }
.DefaultTheme__icon___Q4sZN {
  fill: currentColor;
  margin-right: 5px;
  transform: scale(.85);
}

`, "",{"version":3,"sources":["webpack://./../node_modules/@mulesoft/anypoint-components/raw/platform-components/Sidebar/themes/DefaultTheme.css"],"names":[],"mappings":"AAAA,YAAY;AACZ;EACE,oEAAoE;EACpE,cAAc;EACd,sCAAsC;EACtC,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;AACA,gBAAgB;AAChB;EACE,kGAAkG;;EAElG,mBAAmB;EACnB,oDAAoD;EACpD,aAAa;EACb,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,sEAAsE;UAC9D,8DAA8D;AACxE;AACA;IACI,iFAAiF;;IAEjF,oBAAoB;IACpB,kDAAkD;EACpD;AACF;;IAEI,qBAAqB;EACvB;AACF;IACI,aAAa;EACf;AACF;EACE,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;AACvB","sourcesContent":["/* sidebar */\n.DefaultTheme__sidebar___36TsA {\n  border-right: 1px solid var(--_apc-sidebar-border, var(--aluminum2));\n  flex: 0 0 auto;\n  font-family: var(--lume-g-font-family);\n  font-size: 14px;\n  height: 100%;\n  max-height: 100vh;\n  overflow-y: auto;\n  padding: 20px 0;\n  width: 200px;\n}\n/* back button */\n.DefaultTheme__menu-back___1Lwwk {\n  --_apc-sidebar-menu-back-text-decoration: var(--_apc-sidebar-menu-back-text-decoration-lume, none);\n\n  align-items: center;\n  color: var(--_apc-sidebar-text-color, var(--steel1));\n  display: flex;\n  margin: 30px 0;\n  padding: 0 20px;\n  position: relative;\n  -webkit-text-decoration: var(--_apc-sidebar-menu-back-text-decoration);\n          text-decoration: var(--_apc-sidebar-menu-back-text-decoration);\n}\n.DefaultTheme__menu-back___1Lwwk:hover {\n    --_apc-sidebar-hover-font-weight: var(--_apc-sidebar-hover-font-weight-lume, 400);\n\n    color: var(--steel4);\n    font-weight: var(--_apc-sidebar-hover-font-weight);\n  }\n.DefaultTheme__menu-back___1Lwwk:active,\n  .DefaultTheme__menu-back___1Lwwk:focus {\n    color: var(--primary);\n  }\n.DefaultTheme__menu-back___1Lwwk:focus {\n    outline: none;\n  }\n.DefaultTheme__icon___Q4sZN {\n  fill: currentColor;\n  margin-right: 5px;\n  transform: scale(.85);\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
